import * as React from 'react';
import { ChoicesContext } from "./ChoicesContext.js";
export var ChoicesContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return (React.createElement(ChoicesContext.Provider, { value: value }, children));
};
//# sourceMappingURL=ChoicesContextProvider.js.map